import script from "./RevisitDetailModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RevisitDetailModal.vue?vue&type=script&setup=true&lang=ts"

import "./RevisitDetailModal.vue?vue&type=style&index=0&id=1f4469be&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f4469be"]])

export default __exports__